export default {
  dateFormat: 'DD MMMM YYYY',
  dateTimeFormat: 'DD MMMM YYYY H:mm',
  colors: [
    '#65CCB8',
    '#B8A2FE',
    '#F48E7E',
    '#FB7373',
    '#81C1F2',
    '#82C0D0',
    '#EC80AF',
    '#5783C8',
    '#FFB244',
    '#A8A879',
    '#409FB8',
    '#D6AF85',
    '#AD80AF',
    '#839098',
    '#C36D9B',
    '#B7D293',
    '#BFB2A1',
    '#F0AA77',
    '#8CC07A',
    '#8CACAF'
  ]
}



// WEBPACK FOOTER //
// ./src/services/settings.js